export default "__VITE_PUBLIC_ASSET__f877d461__"